import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

export const condition = (item, isLast) => {
  const label = `& .MuiTableCell-root:${
    isLast ? "last-of-type" : "first-of-type"
  }`;
  const isBehind = dayjs(item.startDate).add(1, "day") < dayjs();

  const expedited = item?.priority === 4;

  return {
    sx: {
      "&.MuiTableRow-root": {
        ...(isBehind && {
          "& .MuiTableCell-root:first-of-type": {
            backgroundColor: "rgba(239, 55, 55, 0.9)",
            color: "hubColors.fontWhite",
          },
        }),
        ...(expedited && {
          backgroundColor: "rgba(38, 180, 255, 0.12) !important",
        }),
        ...(item?.isStarted && {
          backgroundColor: "rgba(223, 158, 68, 0.1)",
        }),
        ...(item?.firstRun && {
          backgroundColor: "rgba(255, 218, 237, 0.41)",
        }),
        ...(item?.isStarted &&
          item?.firstRun && {
            backgroundColor: "rgba(255, 212, 206, 0.41)",
          }),
      },
      ...(isBehind && {
        "&.MuiTableRow-root:hover": {
          [label]: {
            backgroundColor: "rgba(239, 55, 55, 1) !important",
            color: "hubColors.fontWhite",
          },
        },
      }),
      ...(expedited && {
        "&.MuiTableRow-root:hover": {
          backgroundColor: "rgba(38, 180, 255, 0.3) !important",
        },
      }),
    },
  };
};
